import Vue from "vue";

import AboutTheProgram from "./AboutTheProgram.vue";

export function load() {
    const selector = "about-the-program";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(AboutTheProgram, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
